import { queryOptions } from '@tanstack/react-query'
import { getRouteApi } from '@tanstack/react-router'

import { isAdminAuthFailure } from '@gto/api-client'
import {
  type AdminMeResponse,
  getAdminMe,
  getGetAdminMeQueryKey,
} from '@gto/api-client/admin/react-query'

import { isForbidden } from '@/utils/be-error-detail'

const MAX_ME_RETRIES = 3

export const ADMIN_PERMISSIONS = {
  viewAnnouncements: 'account.admin_v2_view_announcements',
  manageAnnouncements: 'account.admin_v2_manage_announcements',
  viewMonkerUploads: 'account.admin_v2_view_monker_uploads',
  manageMonkerUploads: 'account.admin_v2_manage_monker_uploads',
  viewAnalyzerInsights: 'account.admin_v2_view_analyzer_insights',
  manageAnalyzerInsights: 'account.admin_v2_manage_analyzer_insights',
  viewInsider: 'account.admin_v2_view_insider',
  manageInsider: 'account.admin_v2_manage_insider',
  viewBrevo: 'account.admin_v2_view_brevo',
  manageBrevo: 'account.admin_v2_manage_brevo',
} as const

export type AdminPermission = (typeof ADMIN_PERMISSIONS)[keyof typeof ADMIN_PERMISSIONS]

export const meQueryOptions = () =>
  queryOptions({
    queryKey: getGetAdminMeQueryKey(),
    queryFn: ({ signal }) => getAdminMe(signal),
    staleTime: Number.POSITIVE_INFINITY,
    retry: (failureCount, error) =>
      !isAdminAuthFailure(error) && !isForbidden(error) && failureCount < MAX_ME_RETRIES,
  })

export const hasPerm = (me: AdminMeResponse, perm: AdminPermission): boolean =>
  me.permissions.includes(perm)

const layoutRoute = getRouteApi('/_layout')

export const useMe = (): AdminMeResponse =>
  layoutRoute.useRouteContext({ select: (context) => context.me })
